import { createFileRoute } from '@tanstack/react-router'

import { getUIVersion } from 'lib/uiVersion'

import Loggers from 'pages/Loggers'
import LoggersClassic from 'pages/Loggers/Loggers.classic'

const IS_CLASSIC_UI = getUIVersion() === 'classic'

export const Route = createFileRoute('/_auth/loggers/')({
  component: IS_CLASSIC_UI ? LoggersClassic : Loggers,
})
